var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useSelector } from "react-redux";
export var AuthActions;
(function (AuthActions) {
    AuthActions["SET_USER"] = "SET_USER";
})(AuthActions || (AuthActions = {}));
var initialState = {
    user: undefined,
    organization: undefined
};
export var authReducer = function (state, action) {
    var _a, _b, _c, _d, _e;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case AuthActions.SET_USER:
            var serializedUser = __assign(__assign({}, (_a = action.payload) === null || _a === void 0 ? void 0 : _a.user), { consents: (_d = (_c = (_b = action.payload) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.consents) === null || _d === void 0 ? void 0 : _d.map(function (consent) { return (__assign(__assign({}, consent), { acceptedOn: consent.acceptedOn.toISOString() })); }) });
            return __assign(__assign({}, state), { user: serializedUser, organization: (_e = action.payload) === null || _e === void 0 ? void 0 : _e.organization });
        default:
            return state;
    }
};
export var useOrganization = function () {
    return useSelector(function (state) { return state.auth.organization; });
};
